// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login-m_Vfmb4LWb9cXfqwt_ys86 {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.Login-m_Vfmb4LWb9cXfqwt_ys86 > * {
    margin-bottom: 1rem;
}`, "",{"version":3,"sources":["webpack://./client/login/Login/Login.m.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".loginForm {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n\n.loginForm > * {\n    margin-bottom: 1rem;\n}"],"sourceRoot":""}]);
// Exports
export var loginForm = `Login-m_Vfmb4LWb9cXfqwt_ys86`;
export default ___CSS_LOADER_EXPORT___;
